import { z } from 'zod'
import type { EnabledFeatureFlag } from '#/domain/featureFlag/EnabledFeatureFlag'

export const EnabledFeatureFlagDtoSchema = z
  .object({
    Flag: z.string(),
    IsEnabled: z.boolean(),
  })
  .transform((raw): EnabledFeatureFlag => ({
    Flag: raw.Flag,
    IsEnabled: raw.IsEnabled,
  }))

export type EnabledFeatureFlagResponseDto = z.input<typeof EnabledFeatureFlagDtoSchema>

export function toDomain(raw: EnabledFeatureFlagResponseDto): EnabledFeatureFlag {
  return EnabledFeatureFlagDtoSchema.parse(raw)
}

export function toDomainList(raw: EnabledFeatureFlagResponseDto[]): EnabledFeatureFlag[] {
  return raw.map(toDomain)
}
